import { apiClient } from '@/lib/apiClient';
import type { ConversationClassification } from '../types/analytics.types';

// Fixes UTF-8 decoded as Latin-1: "SangrovitÂ®" → "Sangrovit®"
export const cleanProductName = (name: string | null): string | null => {
  if (!name) return null;
  return name.replace(/Â/g, '');
};

export const analyticsService = {
  getClassifications: async (accessToken: string): Promise<ConversationClassification[]> => {
    return apiClient<ConversationClassification[]>('/admin/classifications', {
      headers: { Authorization: `Bearer ${accessToken}` },
      skipAuthErrorHandling: true,
    });
  },
};
